export default "__VITE_ASSET__DK8tDErd__"